import styled from 'styled-components';
import { NAVIGATION_MOBILE_MODE, NAVIGATION_TABLET_MODE, SELECTORS, UBISOFT_BLUE } from '../../constants/constants';

interface INavigationStyle {
  isCurrentPage: boolean;
  isLastItem:boolean;
}

export const NavigationContainer = styled.div`
    ${SELECTORS} & {
      display: flex;
      width: 80%;
      max-width: 1380px;
      margin: 50px auto 70px auto;
      background-color: #3C4145;
      border-radius: 15px;
      flex-wrap: wrap;
      height: 80px;
      justify-content: space-between;
      align-content: center;
    }
    svg{
        display: block;
        margin: auto 0 auto 30px;
    } 
   @media (max-width: ${NAVIGATION_TABLET_MODE}) {
        ${SELECTORS} & {
          height: 60px;
          justify-content: unset;
          align-content: unset;
        }
        svg{
          height: 20px;
          width: 20%;
        }
   }
   @media (max-width: ${NAVIGATION_MOBILE_MODE}) { 
       ${SELECTORS} & {
         width: 100%;
         border-radius: 0;
         overflow: auto;
         white-space: nowrap;
         margin-top: 0;
         .navigation-logo{
            display: none;
         }
       }
   }
   
`;

export const NavigationLineSeparator = styled.div`
    ${SELECTORS} & {
        height: 65%;
        width: 4px;
        background-color: white;
        margin: auto 50px;
    }
    @media (max-width: ${NAVIGATION_MOBILE_MODE}) { 
        ${SELECTORS} & {
            display: none;   
        }
    }
`;

export const NavigationItemsContainer = styled.div`
    ${SELECTORS} & {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
    @media (max-width: ${NAVIGATION_TABLET_MODE}) {
      ${SELECTORS} & {
          margin: auto;
       }
    }
    @media (max-width: ${NAVIGATION_MOBILE_MODE}) { 
        ${SELECTORS} & {
          margin: auto 0;
          overflow-x: scroll;
          overflow-y: hidden;
          display: block;   
        }
    }
`;

export const NavigationItem = styled.a`
    ${SELECTORS} & {
        position: relative;
        font-size: 18px;
        margin: auto ${({ isLastItem }: INavigationStyle) => (isLastItem ? '0' : '60px')} auto 0px;
        font-family: ${props =>props.theme.font.boldText} !important;
        text-decoration: none;
        font-style: normal;
        line-height: 25px;
        text-align: center;
        cursor: pointer;
        text-transform: uppercase;
    }
    color : ${({ isCurrentPage }: INavigationStyle) => isCurrentPage ? UBISOFT_BLUE : 'white'} !important;
    
    ${({ isCurrentPage }: INavigationStyle) => isCurrentPage ? `
        &:before {
        content: '';
        position: absolute;
        right: -30px;
        bottom: -27px;
        left: -30px;
        border-bottom: 4px solid ${UBISOFT_BLUE};
        width: -moz-available;          /* WebKit-based browsers will ignore this. */
        width: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
        width: fill-available;
        margin: auto;
    }
    ` : ''};
    
    
   @media (min-width: ${NAVIGATION_MOBILE_MODE}) { 
      &:hover {
         color: ${UBISOFT_BLUE} !important;
         &:before {
          content: '';
          position: absolute;
          right: -30px;
          bottom: -27px;
          left: -30px;
          width: 100%;
          border-bottom: 4px solid ${UBISOFT_BLUE};
          margin: auto;
        }
      }
    }
    
    
    @media (max-width: ${NAVIGATION_TABLET_MODE}) {
        ${SELECTORS} & {
          font-size: 16px;
          margin: auto 20px auto 0;
          &:before {
            bottom: -16px !important;
          }
        }
    }
    
    @media (max-width: ${NAVIGATION_MOBILE_MODE}) { 
          ${SELECTORS} & {
              margin: auto 10px auto 10px;   
          }
    }
`;

export const NavigationSubscriptionButton = styled.div`
   ${SELECTORS} & {
        margin-right: 30px;
   }
   @media (max-width: ${NAVIGATION_TABLET_MODE}) {
        display: none;
    }
`;